import React from "react";

export default function TouchHistoryTab() {
    // Dữ liệu dòng thời gian lịch sử chạm chuẩn theo hình mẫu
    const timelineData = [
        {
            time: "Hôm nay 08:10",
            content: "WhatsApp · Telesales NV-02 hỏi lại vé máy bay (R22: CSKH không chạm thêm hôm nay)",
        },
        {
            time: "13/10 08:00",
            content: "WhatsApp · NV-02 giữ chỗ tạm đến 31/10",
        },
        {
            time: "13/10 06:40",
            content: 'WhatsApp · khách: "Đợi chốt vé rồi chuyển"',
        },
        {
            time: "12/10 14:00",
            content: "Gọi đi qua WhatsApp · NV-02 · KN-02 Hẹn gọi lại 15/10 11:30",
        },
        {
            time: "12/10 09:25",
            content: "WhatsApp · NV-02 gửi mã QR cọc CO-1012-01",
        },
        {
            time: "12/10 09:00",
            content: "WhatsApp · NV-02 gửi báo giá BG-1012-01 · mã S → S4",
        },
        {
            time: "12/10 07:05",
            content: "WhatsApp · khách hỏi nâng cơ mặt khi về Việt Nam",
        },
        {
            time: "12/10",
            content: "Khách cũ hỏi dịch vụ mới · CSKH giữ, Telesales hỗ trợ báo giá (đề xuất R23 [?]) · đặt giữ chỗ 18/12 → mã C5 → C4",
        },
        {
            time: "03/01/2026",
            content: "Tái khám",
        },
        {
            time: "28/12/2025",
            content: "CSAT 5",
        },
        {
            time: "20/12/2025",
            content: "Thực hiện K·Reskin · thanh toán lần đầu → danh sách CSKH, C0 (R34)",
        },
    ];

    return (
        <div className="space-y-3 pt-1 text-xs animate-fade-in text-gray-800 dark:text-gray-200">
            {/* Dòng quy tắc đầu tab */}
            <div className="text-gray-600 dark:text-gray-300 leading-relaxed pb-1">
                Dòng thời gian gộp cả 2 phòng: cuộc gọi, chat, Zalo, lịch, đổi mã (R14)[cite: 15]
            </div>

            {/* Khung Timeline */}
            <div className="relative pl-4 space-y-4 before:absolute before:left-1.5 before:top-2 before:bottom-2 before:w-0.5 before:bg-blue-300 dark:before:bg-blue-800">
                {timelineData.map((item, idx) => (
                    <div key={idx} className="relative pl-4 space-y-0.5">
                        {/* Chấm tròn mốc thời gian trên đường timeline */}
                        <span className="absolute -left-[15px] top-1 w-2.5 h-2.5 rounded-full bg-[#1d4c7d] border-2 border-white dark:border-[#1f1f1f]"></span>
                        
                        {/* Thời gian */}
                        <div className="font-bold text-[#1d4c7d] dark:text-blue-400">
                            {item.time}
                        </div>
                        
                        {/* Nội dung chi tiết */}
                        <div className="text-gray-700 dark:text-gray-300 leading-relaxed">
                            {item.content}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}